<div *ngIf="loading" class="loading-text">
    <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
  </div>
  
  <div *ngIf="!loading">
  <app-sub-header [pageTitle]="'FinishServiceVoucher' | translate"></app-sub-header>

<div class="padded-container">
    <dx-accordion [collapsible]="true">
        <dxi-item title="{{ 'ProblemsToBeSolved' | translate }}" [expanded]="true">
            <div *ngIf="inServiceCarFaultsResponse?.carFaults?.length">
                <div *ngFor="let fault of inServiceCarFaultsResponse?.carFaults" class="fault-item">
                    <dx-check-box [(value)]="fault.isFixed"></dx-check-box>
                    <dx-text-box [(value)]="fault.faultNotes" [readOnly]="true"></dx-text-box>
                </div>
            </div>
            <div *ngIf="!inServiceCarFaultsResponse?.carFaults?.length">
                <span>{{ 'NoProblemsToBeSolved' | translate }}</span>
            </div>
        </dxi-item>
    </dx-accordion>

    <dx-form>
        <dxi-item itemType="group" caption="{{ 'OdometerLastValue' | translate }}">
            <dx-number-box [(value)]="endOdometrValue" [showSpinButtons]="true" [min]="odometerResponse?.odometerValue?.odometerEndVal"></dx-number-box>
        </dxi-item>
        <dxi-item itemType="group" caption="{{ 'EndTime' | translate }}">
            <div class="row">
                <div class="col-6">
                    <dx-select-box [(value)]="endHours" [dataSource]="hours" displayExpr="value" valueExpr="value"></dx-select-box>
                </div>
                <div class="col-6">
                    <dx-select-box [(value)]="endMinutes" [dataSource]="minutes" displayExpr="value" valueExpr="value"></dx-select-box>
                </div>
            </div>
        </dxi-item>
        <dxi-item itemType="group" caption="{{ 'Date' | translate }}">
            <dx-date-box [(value)]="choosedDate" displayFormat="dd/MM/yyyy"></dx-date-box>
        </dxi-item>
        <dxi-item>
            <div class="button-container">
                <dx-button class="half-width-button" type="default"
                    [text]="isMobile ? '<' : ('PreviousDay' | translate)" 
                    (onClick)="dayBack()">
                </dx-button>
                <dx-button class="half-width-button" type="default" 
                    [text]="isMobile ? '>' : ('NextDay' | translate)" 
                    (onClick)="dayForward()">
                </dx-button>
            </div>
        </dxi-item>
        <dxi-item itemType="group" caption="{{ 'Comment' | translate }}">
            <dx-text-area [(value)]="comment" [autoResizeEnabled]="true"></dx-text-area>
        </dxi-item>
    </dx-form>

    <dx-button text="{{ 'Save' | translate }}" (onClick)="endVoucher()" type="success" class="full-width-button"></dx-button>
    <dx-button text="{{ 'Back' | translate }}" (onClick)="navigateBack()" type="default" class="full-width-button"></dx-button>
</div>

<dx-popup
  [(visible)]="showPopup"
  [width]="isMobile ? '100%' : '60%'"
    [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile"
  [showTitle]="true"
  [hideOnOutsideClick]="false" [showCloseButton]="true"
  title="{{ 'Notification' | translate }}"
  (onHiding)="closePopup()">
  <div>{{ popupMessage }}</div>
</dx-popup>
